export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K, props: Partial<HTMLElementTagNameMap[K]> & { class?: string; dataset?: Record<string, string>; attrs?: Record<string, string> } = {},
  ...children: Array<Node | string | null | undefined>
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  const { class: cls, dataset, attrs, ...rest } = props as Record<string, unknown> & { class?: string; dataset?: Record<string, string>; attrs?: Record<string, string> };
  if (cls) node.className = cls;
  if (dataset) for (const [k, v] of Object.entries(dataset)) node.dataset[k] = v;
  if (attrs) for (const [k, v] of Object.entries(attrs)) node.setAttribute(k, v);
  for (const [k, v] of Object.entries(rest)) {
    // @ts-expect-error dynamic assignment to HTMLElement
    node[k] = v;
  }
  for (const c of children) {
    if (c == null) continue;
    node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
  }
  return node;
}

export function clear(node: HTMLElement) { while (node.firstChild) node.removeChild(node.firstChild); }

export function mount(parent: HTMLElement, ...children: Array<Node | string>) {
  for (const c of children) parent.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
}

let toastTimer: number | null = null;
export function toast(msg: string, ms = 2200) {
  const existing = document.querySelector('.toast');
  if (existing) existing.remove();
  const t = el('div', { class: 'toast' }, msg);
  document.body.appendChild(t);
  if (toastTimer) window.clearTimeout(toastTimer);
  toastTimer = window.setTimeout(() => t.remove(), ms);
}
